import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';

@Component({
  standalone: false,
  selector: 'app-manage-tools-dialog',
  templateUrl: './manage-tools-dialog.component.html',
  styleUrls: ['./manage-tools-dialog.component.css']
})

export class ManageToolsDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  formGroup!: FormGroup;
  isEdit: boolean = false;
  invalidInput1: boolean = false;
  invalidInput2: boolean = false;
  validForm: boolean = true;

  errorMessages: any;

  constructor(
    public dialogRef: MatDialogRef<ManageToolsDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService,
    private techsService: TechnologiesManagementService,
    private infoBar: InfoBarWithStatusService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.isEdit = this.local_data.edit;

    if (this.isEdit) {
      this.formGroup = this._formBuilder.group({
        techNameCtrl: [{ value: this.local_data.tecName, disabled: true }],
        toolNameCtrl: [this.local_data.toolName, Validators.required],
        toolProdCtrl: [this.local_data.productivity.toFixed(2), [
          Validators.required,
          Validators.min(1),
          Validators.max(100)
        ]],
      });
    }
    else {
      this.formGroup = this._formBuilder.group({
        techNameCtrl: [{ value: this.local_data.tecName, disabled: true }],
        toolNameCtrl: ['', Validators.required],
        toolProdCtrl: ['', [
          Validators.required,
          Validators.min(1),
          Validators.max(100)
        ]],
      });
    }

    this.errorMessages = {
      "Only SUPER-ADMIN or ADMIN can add a tool.": this.variables.onlySuperAdminOrAdminCanAddTool,
      "Technology not found": this.variables.technology + this.variables.notFound,
      "A tool with this name already exists in the technology.": this.variables.toolNameAlreadyExists,
      "Tool name is required.": this.variables.toolNameRequired,
      "Productivity must be a non-negative number.": this.variables.numberBetweenZeroUndred,
      "Access denied.": this.variables.notAuthorized,
      "Old tool name is required": this.variables.oldToolNameRequired,
      "Tool not found in technology": this.variables.toolNotFoundInTechnology,
      'Invalid JWT token': this.variables.sessionExpired,

    };

  }

  cleanErrors() {
    this.invalidInput2 = false;
  }

  doAction() {
    this.cleanErrors();
    this.formGroup.markAllAsTouched();

    const control = this.formGroup.get('toolProdCtrl');

    if (control?.errors?.['required']) {
      this.invalidInput2 = true;
    }
    if (control?.errors?.['min']) {
      this.invalidInput2 = true;
    }
    if (control?.errors?.['max']) {
      this.invalidInput2 = true;
    }


    if (this.formGroup.valid) {
      console.log(control);

      if (!this.local_data.edit) {
        this.techsService.addToolToTechnology(this.local_data.techId, this.formGroup.value.toolNameCtrl, this.formGroup.value.toolProdCtrl).subscribe
          ({
            next: (data) => {

              if (data) {
                this.dialogRef.close({ data: { success: true } });
              }
            },
            error: (error) => {
              console.error('Error:', error.error);

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);


            }
          })
      }
      else {
        this.techsService.editToolFromTechnology(this.local_data.techId, this.local_data.toolName, this.formGroup.value.toolNameCtrl, this.formGroup.value.toolProdCtrl).subscribe
          ({
            next: (data) => {

              if (data) {
                this.dialogRef.close({ data: { success: true } });
              }
            },
            error: (error) => {
              console.error('Error:', error.error);

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);


            }
          })
      }
    }


  }

}
